import { LeaveInitialState } from "../../../types/hr/hrInterface";
import { HrActionTypes, HrActions } from "../../actionTypes/hr/hrActionTypes";

const initialState: LeaveInitialState = {
  leaveStatus: "APPLIED",
  leaveList: [],
  leaveData: {
    id: 0,
    status: "",
    from_date: undefined,
    to_date: undefined,
    employee_id: 0,
    remarks: "",
    reason: "",
    created_by: 0,
  },
  leaveListPageCount: 0,
};

export default function leaveReducer(state = initialState, action: HrActionTypes): LeaveInitialState {
  switch (action.type) {

    case HrActions.SET_LEAVE_STATUS:
      return {
        ...state,
        leaveStatus: action.payload,
      };

    case HrActions.SET_LEAVE_LIST:
    return {
      ...state,
      leaveList: action.payload,
    };

  case HrActions.SET_LEAVE_LIST_PAGE_COUNT:
    return {
      ...state,
      leaveListPageCount: action.payload,
    };

  case HrActions.SET_LEAVE_DATA:
    return {
      ...state,
      leaveData: action.payload,
    };

    default:
      return state;
  }
}
